import { useMutation } from '@tanstack/react-query'

import { type AdditionalParticipant, type ParticipantFormProps } from 'components/member_onboarding_v2/types'
import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export function useCreateMemberOnboardingAdditionalParticipant ({
  enrollmentEventId,
}: {
  enrollmentEventId: string;
}) {
  return useMutation<
    AdditionalParticipant,
    GrapeAPIErrorType,
    ParticipantFormProps
  >({
    mutationFn: async (data: ParticipantFormProps) => {
      const response = await fetchWithHeaders(
        `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/additional_participants`,
        {
          method: 'POST',
          body: JSON.stringify(data),
        }
      )
      const responseJson = await response.json()
      if (!response.ok) {
        const errors = responseJson
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
          fieldErrors: errors.field_errors,
          requestId: response.headers.get('x-request-id') ?? undefined,
        })
      }
      return responseJson
    },
  })
}
